import { render } from "./SingleSlider.vue?vue&type=template&id=cd7224b8&scoped=true"
import script from "./SingleSlider.vue?vue&type=script&lang=js"
export * from "./SingleSlider.vue?vue&type=script&lang=js"

import "./SingleSlider.vue?vue&type=style&index=0&id=cd7224b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd7224b8"]])

export default __exports__